import isEmpty from 'lodash/isEmpty'

const FILTERS = {
  advanced: {
    _in: [
      'requested',
      'advanced',
      'pendingReview',
      'approved',
      'pendingAdvance',
    ],
  },
  delayed: { _eq: 'delayed' },
  late: { _eq: 'late' },
  paid: { _in: ['paid', 'settle', 'settlementCompleted'] },
}

const queries = (query) => {
  switch (query.name) {
    case 'INVOICE_TAB':
      return {
        state: FILTERS[query.values['state']],
      }
    case 'PAYMENT':
      return {
        state: { _eq: 'completed' },
      }
    default:
      return {}
  }
}

const getQueryFields = (fields) => {
  return fields.reduce((queryObject, queryFields) => queries(queryFields), {})
}

export const getQuery = (fields) => {
  const unformattedQuery = getQueryFields(fields)
  if (isEmpty(unformattedQuery)) {
    return {}
  }

  return {
    clause: {
      ...unformattedQuery,
    },
  }
}
